export default __webpack_public_path__ + "static/media/thin-submit.31a81fd6.svg";